import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksSalesInvoiceFields', {
    customerFieldTitle: 'Customer',
    invoiceNumberFieldTitle: 'Invoice #',
    emptyInvoiceNumber: 'Allocated on approval',
    termsFieldTitle: 'Terms',
    dateFieldTitle: 'Invoice date',
    dueDateFieldTitle: 'Due date',
    billingAddressDateFieldTitle: 'Billing address',
});
